import { render } from "./pfoGalerie.vue?vue&type=template&id=8a3ed0c8"
import script from "./pfoGalerie.vue?vue&type=script&lang=js"
export * from "./pfoGalerie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__